export function change_expert_profile_photo()
{
    let photoChangeProfileButton = document.querySelector( '.js_change_expert_avatar' );
    let profileImageUpload = document.querySelector( '.upload_profile_image' );
    photoChangeProfileButton.addEventListener( 'click', event => {
        event.preventDefault();
        profileImageUpload.click();
    } );
}